import { h } from 'preact';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Components
import Text from '../../Global/Text';
import { stepComponents } from '../../../constants/Steps';
import { stepHasRequiredData, stepShowHide } from '../../../utilities/form/formUtils';
import Icon from '../../Global/Icon';

const TextBlock = ({
  columns,
  body,
  type,
  list,
  title,
  desc,
  descMore,
  variant,
  bodyClass,
  titleClass,
  listProps,
  dispatch,
  userData,
  hidden,
  messages,
  numberFormat,
  currencyFormat,
  setValues,
  icon,
}) => {
  if (hidden) {
    return <div/>;
  }

  const isHeader = type === 'textHeader';
  const textClasses = classNames(
    'text', {
      [`text--${type}`]: type,
      [`text--${variant}`]: variant,
      [`text--${columns}col`]: columns,
      'text--splash-banner': type === 'splashBanner',
    }
  );
  const titleClasses = `text__title ${titleClass}`;
  const bodyClasses = `text__body ${bodyClass}`;

  let more = descMore;
  if (more && typeof more === 'object' && !more.nodeName) {
    const params = { ...descMore, dispatch, setValues };
    const Component = stepComponents[params.type];
    more = <Component {...params} />;
  }

  return (
    <div className={textClasses}>

      {title &&
      <Text className={titleClasses} component={isHeader ? 'h4' : 'h5'} value={title} numberFormat={numberFormat} currencyFormat={currencyFormat}/>
      }

      {body &&
      <Text className={bodyClasses} component="p" value={body} numberFormat={numberFormat} currencyFormat={currencyFormat}/>
      }

      {icon &&
      <Icon icon={icon}/>
      }

      {list &&
      <ul className="text__list">
        {list.map(listItem => <Text className="list-item" component="li" value={listItem} numberFormat={numberFormat} currencyFormat={currencyFormat}/>)}
        {listProps &&
        (listProps.length > 0 &&
          listProps.map(listProp => {
            const { showHide } = listProp;
            const inputParams = {
              ...listProp,
              userData,
              dispatch,
              hidden: (stepShowHide(listProp.hidden, showHide, userData, {})),
            };
            const InputComponent = stepComponents[listProp.type];
            const isValid = stepHasRequiredData(
              listProp.requiredData,
              userData,
              null
            );
            if (inputParams.hidden || !isValid) {
              return '';
            }
            return (<li className="list-item"><InputComponent {...inputParams}/></li>);
          })
        )
        }
      </ul>
      }

      {desc &&
      <Text className="text__desc" component="p" value={desc} more={more} numberFormat={numberFormat} currencyFormat={currencyFormat}/>
      }

      {messages &&
      messages.map(message => <Text component="p" value={message} numberFormat={numberFormat} currencyFormat={currencyFormat}/>)
      }

    </div>
  );
};

export default TextBlock;

TextBlock.defaultProps = {
  columns: '12',
  body: null,
  list: null,
  title: null,
  desc: null,
  descMore: null,
  variant: null,
  titleClass: '',
  bodyClass: '',
  listProps: null,
  messages: null,
  numberFormat: false,
  currencyFormat: false,
  icon: null,
};

TextBlock.propTypes = {
  type: PropTypes.string.isRequired,
  list: PropTypes.array,
  columns: PropTypes.string,
  body: PropTypes.string,
  title: PropTypes.string,
  desc: PropTypes.string,
  descMore: PropTypes.object,
  variant: PropTypes.string,
  titleClass: PropTypes.string,
  bodyClass: PropTypes.string,
  listProps: PropTypes.array,
  dispatch: PropTypes.func.isRequired,
  userData: PropTypes.object.isRequired,
  hidden: PropTypes.bool.isRequired,
  messages: PropTypes.array,
  numberFormat: PropTypes.bool,
  currencyFormat: PropTypes.bool,
  setValues: PropTypes.func.isRequired,
  icon: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Steps/General/TextBlock.jsx